import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isLogin: false,
        upImgUrl: '',
        catchArr: [],
        upHeaderImg: '',
        upPoster: '',
        upAlbum: '',
        url: 'http://jingwen.bigboluo.com/index.html'
    },
    mutations: {
        setisLogin: (state, value) => {
            state.isLogin = value
        },
        setupImgUrl: (state, value) => {
            console.log('store触发')
            state.upImgUrl = value
        },
        setupHeaderImg: (state, value) => {
            console.log(state,value)
            state.upHeaderImg = value
        },
        setupPoster: (state, value) => {
            console.log(state,value)
            state.upPoster = value
        },
        setUrl: (state, value) => {
            console.log(state,value)
            state.url = value
        },
        setupalbumUrl: (state, value) => {
            console.log(state,value)
            state.upAlbum = value
        },
        isKeepAlive(state, component) {
            !state.catchArr.includes(component) && state.catchArr.push(component);
        },
        // 对指定组件进行动态更改缓存（不缓存）--组件调用该方法时，从缓存数组中删除对应的组件元素
        noKeepAlive(state, component) {
            let index = state.catchArr.indexOf(component);
            index > -1 && state.catchArr.splice(index, 1);
        },
    },
    getters: {
        // showloginFun = showloginFun 
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js